import React from 'react';
import {
    Button,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select
} from '@material-ui/core'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { Controller } from 'react-hook-form'
import { styleCertificate } from '../styleCertificate';
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import utils from '../../../utils/utils';

const SearchEmployeeContract = ({
    handleSubmit,
    onSubmit,
    errors,
    control,
    register,
    cleanForm,
    maestras,
    getValues,
    currentDate,
    setMinDate,
    setMaxInitDate,
    minDate,
    maxInitDate
}) => {
    const classes = styleCertificate();

    const onChangeDate = (value) => {
        setMinDate(value);
    };

    const validateMaxInitDate = () => {
        var currentData = getValues();
        if (!currentData.endDate) {
          setMaxInitDate(utils.getFormattedDateMMddyyyy(currentDate, "."));
        } else {
          setMaxInitDate(utils.getFormattedDateMMddyyyy(currentData.endDate, "."));
        }
    };

    const updateMaxInitDate = (date) => {
        var currentData = getValues();
        if (!currentData.initDate) {
          setMaxInitDate(date);
        } else {
          setMaxInitDate(utils.getFormattedDateMMddyyyy(currentDate, "."));
        }
    };

  return (
    <div>
        <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>

                    <Grid item xs={12} md={3} lg={3}>
                        <FormControl
                            variant="outlined"
                            fullWidth
                            className={classes.inputForm}
                            size="small"
                            error={
                            !!errors.hasOwnProperty("linkageType") &&
                            errors["linkageType"].message
                            }
                        >
                            <InputLabel htmlFor="outlined-select-linkageType" shrink={true}>
                                Tipo de vinculación
                            </InputLabel>
                            <Controller
                                fullWidth
                                control={control}
                                name="linkageType"
                                inputRef={register}
                                defaultValue=''
                                className={classes.inputForm}
                                label="Tipo de vinculación"
                                size="small"
                                notched={true}
                                inputProps={{
                                    name: "linkageType",
                                    id: "outlined-select-linkageType",
                                }}
                                as={
                                    <Select>
                                        {
                                            maestras?.tiposDeVinculacionContratos?.map((item) => (
                                                <MenuItem
                                                    className={classes.menuItem}
                                                    key={item.clave}
                                                    value={item.clave}
                                                >
                                                    {item.valor}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                }
                            />
                            <FormHelperText style={{color: "#f44336", paddingLeft: 14}}>
                                {errors.hasOwnProperty("linkageType") && errors["linkageType"].message}
                            </FormHelperText>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={2} lg={2}>
                        <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                            <Controller
                            as={
                                <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                variant="inline"
                                format="dd/MM/yyyy"
                                className = {classes.dropdown}
                                dateFormat="DD/MM/YYYY"
                                label="Desde"
                                InputLabelProps={{ shrink: true }}
                                onAccept={onChangeDate}
                                onOpen={validateMaxInitDate}
                                error={
                                    !!errors.hasOwnProperty("initDate") &&
                                    errors["initDate"].message
                                }
                                helperText={
                                    errors.hasOwnProperty("initDate") &&
                                    errors["initDate"].message
                                }
                                minDate="01.01.2020"
                                maxDate={maxInitDate}
                                />
                            }
                            control={control}
                            name="initDate"
                            defaultValue={null}
                            placeholder="Desde"
                            size="small"
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12} md={2} lg={2}>
                    <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                        <Controller
                        as={
                            <KeyboardDatePicker
                            fullWidth
                            inputVariant="outlined"
                            variant="inline"
                            format="dd/MM/yyyy"
                            dateFormat="DD/MM/YYYY"
                            className = {classes.dropdown}
                            label="Hasta"
                            InputLabelProps={{ shrink: true }}
                            onAccept={updateMaxInitDate}
                            error={
                                !!errors.hasOwnProperty("endDate") &&
                                errors["endDate"].message
                            }
                            helperText={
                                errors.hasOwnProperty("endDate") &&
                                errors["endDate"].message
                            }
                            minDate={minDate ? minDate : "01.01.2020"}
                            //maxDate={maxDate}
                            />
                        }
                        control={control}
                        name="endDate"
                        defaultValue={null}
                        placeholder="Hasta"
                        size="small"
                        />
                    </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12} md={4} lg={4} style={{textAlign: 'center'}}>
                        <Button
                            type='submit'
                            variant="contained"
                            className={classes.buttonSearch}
                            >
                            Buscar
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                            variant="contained"
                            className={classes.buttonSearch}
                            onClick={cleanForm}
                        >
                            Limpiar
                        </Button>
                    </Grid>

                </Grid>
            </form>
    </div>
  )
}

export default SearchEmployeeContract